
import axios from 'axios'
import transactionService from '../services/transactionService'
import TransactionLogService from '../services/transactionLogService'
import userService from '../services/userService'
import PetitionService from '../services/petitionService'
import UptimeService from '../services/UptimeService'
import Freshdesk from '../services/FreshdeskService'
let baseUrl = '/api';

// Axios Configuration
axios.defaults.headers.common.Accept = 'application/json'

export default {

    transactionService: new transactionService(axios, baseUrl),
    userService: new userService(axios, baseUrl),
    transactionLogService: new TransactionLogService(axios, baseUrl),
    petitionService: new PetitionService(axios, baseUrl),
    UptimeService: new UptimeService(axios, baseUrl),
    FreshdeskService: new Freshdesk(axios, baseUrl),

}







// WEBPACK FOOTER //
// ./src/store/services.js